import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    exploreWallets: 'Explore wallets',
  },
  fr: {
    exploreWallets: 'Découvrir les sous‑comptes',
  },
} as const);

export default locales;
